import React, { useState, useEffect } from 'react';
import { replace, get, filter, size, map, toNumber, isEmpty, toString } from 'lodash';
import { withApollo } from 'react-apollo';
import { string, func, array, object } from 'prop-types';
import { FlexContainer, Row, Column, Button, FormSelect, Text } from '../../common';
import CompanyGroupsSelect from '../../common/Select/CompanyGroupsSelect';
import ModalConfirmation from './ModalConfirmation';
import { WHITE } from '../../../utils/colors';
import SWITCH_EXTERNAL_ISSUE from '../../../queries/SWITCH_EXTERNAL_ISSUE';

const Filters = ({
        currentValue,
        onChangeSalesChannels,
        selectedSalesChannels,
        salesChannelsOptions,
        motives,
        client,
        email,
        onSearch,
        refetchIssueLogs
    }) => {
    const fullWidth = currentValue === '100%';
    const [companyGroup, setCompanyGroup] = useState({ label: 'Jumbo', value: 'Jumbo' });
    const [selectedMotive, setSelectedMotive] = useState({});
    const [showModalConfirmation, setShowModalConfirmation] = useState(false);
    const [loading, setLoading] = useState(false);
    const activeMotives = map(filter(motives, { isActive: true }), ({ id, name }) => {
        return {
            value: id,
            label: name
        };
    });

    useEffect(() => {
        onChangeSalesChannels([]);
    }, [companyGroup]);

    const onCloseModal = () => {
        setShowModalConfirmation(false);
    };

    const salesChannelByCompanySelect = () => {
        return <Row gap={15}>
            <Column>
                <CompanyGroupsSelect
                    width='100%'
                    onChange={(value) => setCompanyGroup(value)}
                    initialValue={{ label: 'Jumbo', value: 'Jumbo' }}
                />
            </Column>
            <Column>
                <FormSelect
                    label='Tienda'
                    onChange={(values) => onChangeSalesChannels(values)}
                    style={{ width: '100%' }}
                    value={selectedSalesChannels}
                    multiple
                    options={filter(salesChannelsOptions, { kind: get(companyGroup, 'value') })}
                />
            </Column>
        </Row>;
    };

    const onSubmit = async () => {
        setLoading(true);
        await client.mutate({
            mutation: SWITCH_EXTERNAL_ISSUE,
            variables: { input: {
                storeId: map(selectedSalesChannels, ({ value }) => toString(value)),
                storeFlag: get(companyGroup, 'value'),
                issueId: toNumber(get(selectedMotive, 'value')),
                issueName: get(selectedMotive, 'label'),
                user: email,
                isTurningOn: true
            } }
        }).then((_) => {
            setShowModalConfirmation(false);
            setLoading(false);
            refetchIssueLogs();
        });
    };

    return (
        <FlexContainer direction='column' paddingHorizontal={23} paddingVertical={15} gap={15}>
            <Row
                border='1px solid #eaeaea'
                borderRadius={3}
                padding='3px 13px'
                backgroundColor='white'
                gap={13}
            >
                {salesChannelByCompanySelect()}
                <Row
                    width='100%'
                    justify='flex-end'
                    align='flex-end'
                    mB={10}
                    gap={13}
                >
                    <Button text='Limpiar' onClick={() => {
                        onChangeSalesChannels({ value: [] });
                        setSelectedMotive({});
                    }} link width={100} />
                    <Button text='Buscar' onClick={onSearch} width={100} />
                </Row>
            </Row>
            <Row
                borderRadius={3}
                padding='3px 13px'
                justify='space-between'
                align='center'
                backgroundColor={WHITE}
            >
                <Text text='Factores externos' strong size={15} />
                <FormSelect
                    disabled={!(size(selectedSalesChannels) > 0)}
                    placeholder='Seleccione motivo'
                    options={activeMotives}
                    value={selectedMotive}
                    style={{ width: `${parseInt(replace(currentValue, '%', '')) * 2}%` }}
                    onChange={({ value }) => setSelectedMotive(value)}
                />
                <FlexContainer
                    width={fullWidth ? '100%' : undefined}
                    align='center'
                    gap={13}
                >
                    <Button text='Iniciar incidencia' onClick={() => setShowModalConfirmation(true)} width={140} disabled={isEmpty(selectedMotive) || isEmpty(selectedSalesChannels)} />
                </FlexContainer>
            </Row>
            <ModalConfirmation
                onClose={onCloseModal}
                visible={showModalConfirmation}
                onSubmit={() => onSubmit()}
                loading={loading}
                title='aplicar esta incidencia'
                msg='Al aceptar, se agregará la incidencia a las tiendas seleccionadas.'
            />
        </FlexContainer>
    );
};

Filters.propTypes = {
    currentValue: string,
    onChangeSalesChannels: func,
    selectedSalesChannels: array,
    salesChannelsOptions: array,
    motives: array,
    client: object,
    email: string,
    onSearch: func,
    refetchIssueLogs: func
};

export default withApollo(Filters);
